import React from "react";
import { ChevronDownIcon } from "../StrategyCanvasHelpers";
import "./CanvasBand.scss";

// One collapsible canvas band (Growth Strategy / Competitive Strategy / Core
// Strategy / Business DNA) wrapping its sub-sections. Shared by Review Mode
// and Live Review so both screens group blocks exactly the way the canvas
// draws them - the hierarchy itself lives in StrategyCanvasStructure.js.
const CanvasBand = ({
  label,
  color,
  reviewedCount = 0,
  totalCount = 0,
  showProgress = true,
  // Live Review's stat instead of the progress bar: how many blocks in this
  // band still need working through. Mirrors the band header the CEO sees on
  // their Coach Remarks screen, so the same band reads the same on both sides.
  // Pass null to show nothing.
  openCount = null,
  expanded,
  onToggle,
  children,
}) => {
  const percent = totalCount
    ? Math.round((reviewedCount / totalCount) * 100)
    : 0;

  return (
    <div
      className={`cb-band cb-band--${color}${expanded ? " cb-band--open" : ""}`}
    >
      <button
        type="button"
        className="cb-band-header"
        onClick={onToggle}
        aria-expanded={expanded}
      >
        <span className="cb-band-bar" />
        <span className="cb-band-label">{label}</span>
        <span className="cb-band-meta">
          {showProgress && totalCount > 0 && (
            <span className="cb-band-progress">
              {reviewedCount}/{totalCount} reviewed
              <span className="cb-band-track">
                <span
                  className="cb-band-fill"
                  style={{ width: `${percent}%` }}
                />
              </span>
            </span>
          )}
          {openCount !== null &&
            (openCount > 0 ? (
              <span className="cb-band-stat cb-band-stat--open">
                <span className="cb-band-stat-dot" />
                {openCount} to discuss
              </span>
            ) : (
              <span className="cb-band-stat">All finalised</span>
            ))}
          <span className="cb-band-chevron">
            <ChevronDownIcon />
          </span>
        </span>
      </button>

      {expanded && <div className="cb-band-body">{children}</div>}
    </div>
  );
};

// The optional third level - "Customer Focus" / "Remarkable Promise" /
// "Core Business Strategy". A group with no label renders as a bare fragment
// so ungrouped sections don't pick up an extra indent or rail.
export const CanvasGroup = ({ label, children }) =>
  label ? (
    <div className="cb-group">
      <p className="cb-group-label">{label}</p>
      {children}
    </div>
  ) : (
    <>{children}</>
  );

export default CanvasBand;
